import type { PageProps } from '@@/types';
// Definiere die Types für die Menüstruktur
export interface IMenuItem {
  additionalUrlMatches?: string[];
  class?: string;
  icon: string;
  inertia?: boolean;
  label: string;
  permission?: 'server-admin';
  tag?: keyof PageProps['auth']['counts'];
  url: string;
  urlMatch?: string | string[];
}

export interface IMenuSection {
  items: IMenuItem[];
  label: string;
  permission?: 'server-admin';
}

// EXPORTIERE DAS MENÜ-ARRAY UND DIE TYPES
const menu: IMenuSection[] = [
  {
    items: [
      {
        icon: 'fas:user-gear',
        label: 'l.user.edit',
        url: route('user.edit'),
      },
      {
        additionalUrlMatches: ['runners/create', '/user/add'],
        icon: 'fas:person-running',
        label: 'l.manageRunners',
        url: route('runners.manage'),
      },
      {
        icon: 'fas:users',
        label: 'l.teams',
        tag: 'teams',
        url: route('team.index'),
      },
    ],
    label: 'l.management',
  },
  {
    items: [
      {
        icon: 'far:sun',
        label: 'l.events',
        url: route('events.index'),
      },
      {
        additionalUrlMatches: ['/admin/races/{id}'],
        icon: 'far:compass',
        inertia: true,
        label: 'l.races.default',
        url: route('races.index'),
      },
      {
        icon: 'fas:cloud',
        inertia: true,
        label: 'l.cloudO',
        url: route('cloud-o-days.index'),
      },
      {
        icon: 'fas:brackets-square',
        inertia: true,
        label: 'l.fixFinder',
        url: route('fix-finder.index'),
      },
      {
        additionalUrlMatches: ['/races/{id}/results'],
        icon: 'far:square-poll-horizontal',
        inertia: true,
        label: 'l.results',
        url: route('results.index'),
      },
      {
        icon: 'far:trophy',
        inertia: true,
        label: 'l.overallRankings',
        url: route('championships.index'),
      },
      {
        icon: 'far:calendar-check',
        label: 'l.registered',
        tag: 'checkedOutCartItems',
        url: route('cart.registered'),
      },
    ],
    label: 'l.events',
  },
  {
    items: [
      {
        icon: 'fas:cart-shopping',
        label: 'l.cart.default',
        tag: 'cartItems',
        url: route('cart.index'),
      },
      {
        additionalUrlMatches: ['/cart/transaction/{id}'],
        icon: 'fas:receipt',
        label: 'l.invoices.default',
        tag: 'transactions',
        url: route('cart.invoicesList'),
      },
    ],
    label: 'l.transactions',
  },
  {
    items: [
      {
        icon: 'fal:calendar-plus',
        label: 'l.event.create',
        permission: 'server-admin',
        url: route('races.create'),
      },
    ],
    label: 'l.organizer',
  },
  {
    items: [
      {
        icon: 'fal:lightbulb-on',
        label: 'l.featureRequest',
        url: route('feature.ideas'),
      },
      {
        icon: 'fal:list-check',
        label: 'l.roadmap',
        url: route('feature.roadmap'),
      },
    ],
    label: 'l.olEvents',
  },
  {
    items: [
      {
        class: 'waves-effect waves-cyan',
        icon: 'fal:user-shield',
        label: 'l.dashboard',
        permission: 'server-admin',
        url: route('admin'),
      },
      {
        class: 'waves-effect waves-cyan',
        icon: 'fal:envelope',
        label: 'l.informationMail',
        permission: 'server-admin',
        url: route('admin.informationMail'),
      },
      {
        class: 'waves-effect waves-cyan',
        icon: 'fad:user-group',
        label: 'l.checkduplicates',
        permission: 'server-admin',
        url: route('management.checkDuplicates'),
      },
      {
        class: 'waves-effect waves-cyan',
        icon: 'fad:user-group',
        label: 'l.transactions',
        permission: 'server-admin',
        url: route('admin.transactions.index'),
      },
      {
        class: 'waves-effect waves-cyan',
        icon: 'fad:user-group',
        label: 'l.finances.default',
        permission: 'server-admin',
        url: route('admin.finance'),
      },
      {
        class: 'waves-effect waves-cyan',
        icon: 'fal:users-gear',
        label: 'l.accounts',
        permission: 'server-admin',
        url: route('accounts.index'),
      },
    ],
    label: 'l.admin',
    permission: 'server-admin',
  },
];

export default menu;
